import { isUserAdminTier } from './checkUserTierService';

export const getDataNotFoundPage = tier => {
  return isUserAdminTier(tier) ? '/page-not-found' : '/permissions';
};
